import http from '../../services/http-common';
import { 
  PdfGrid, PdfPen, PdfBitmap, PdfBrushes, PdfDocument, PdfBorders, PdfPage, 
  PdfColor, PdfSolidBrush, PdfFontStyle, PdfPageSize, PdfPageOrientation, 
  PdfAlignmentStyle, PdfStringFormat, PdfTextAlignment, PdfStandardFont, PointF,PdfVerticalAlignment,PdfPaddings,
  PdfFontFamily ,PdfMargins
} from "@syncfusion/ej2-pdf-export"; 
import moment from 'moment';


class SaleInvoiceService {
  getForList() {
    return http.get(`/digitalInvoicing/getSaleInvoice`);
    // return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=1`);
  }
  getSaleInvoiceForList(SaleInvoiceID , IsProduction =0) {
    return http.get(`/digitalInvoicing/getSaleInvoiceForList?SaleInvoiceID=${SaleInvoiceID}&IsProduction=${IsProduction}`);
    // return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=1`);
  }
  getCompanyView() {
    return http.get(`/digitalInvoicing/getCompanyView`);
  }
  getBuyerRegistrationType(data) {
    let queryParams = new URLSearchParams({CompanyID:data.CompanyID}).toString();
    return http.post(`/digitalInvoicing/dist/v1/Get_Reg_Type_axios  ` ,data);
  }

  getsaleTypeDataSource(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID:CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/transtypecode?${queryParams}`);
  }
  
  getItemDescCode(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID:CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/itemdesccode?${queryParams}`);
  }
  
  getRateDDSource(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/SaleTypeToRate?${queryParams}`);
  }
  getUOMDDSource(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/HS_UOM?${queryParams}`);
  }
  
  validatePostData(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/validateinvoicedata?${queryParams}`,data);
  }
  validatePostDataTesting(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/validateinvoicedata_sb?${queryParams}`,data);
  }
  getSroScheduleDD(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v1/SroSchedule?${queryParams}`);
  }
  
  getSroItemCode(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/digitalInvoicing/pdi/v2/SROItem?${queryParams}`);
  }
  
  
  getDoctypeCode(CompanyID) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.get(`/digitalInvoicing/pdi/v1/doctypecode?${queryParams}`);
  }
  
  
  PostData(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/postinvoicedata?${queryParams}`,data);
  }
  
  PostDataTesting(CompanyID , data) {
    let queryParams = new URLSearchParams({CompanyID}).toString();
    return http.post(`/digitalInvoicing/di_data/v1/di/postinvoicedata_sb?${queryParams}`,data);
  }
  
  
  
  
  
  deleteInvoice(data) {
    return http.delete(`/digitalInvoicing/di_data/v1/di/deleteTransaction?SaleInvoiceID=${data.SaleInvoiceID}`);
  }


  insert(data) {
    return http.post(`/digitalInvoicing/di_data/v1/di/SaleInvoiceDetail`, data);
  }
  updateInvoices(data) {
    return http.put(`/digitalInvoicing/di_data/v1/di/updateFBRInvoiceInfo`, data);
  }
  create(data) {
    return http.post(`/SaleInvoice/add`, data);
  }

  update(data) {
    return http.put(`/SaleInvoice/update`, data);
  }
















  // ========= GENERATING SALE INVOICE REPORT ==============


   wrapText(graphics, text, font, brush, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    let yOffset = y;
  
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = font.measureString(testLine).width;
  
      if (testWidth > maxWidth && i > 0) {
        graphics.drawString(line.trim(), font, null, brush, x, yOffset);
        line = words[i] + " ";
        yOffset += lineHeight;
      } else {
        line = testLine;
      }
    }
  
    if (line) {
      graphics.drawString(line.trim(), font, null, brush, x, yOffset);
    }
  }
  async SalesTaxInvoiceReport   (invoiceDetails, invoiceItems,blob, type = 'download') {
    const document = new PdfDocument();
  
    // Page settings
    document.pageSettings.margins.all = 10;
    document.pageSettings.margins.bottom = 5;
    document.pageSettings.size = PdfPageSize.a4;
  
    // Add page
    const page = document.pages.add();
    const graphics = page.graphics;
  
    // Fonts & brushes
    const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 16, PdfFontStyle.Bold);
    const subFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
    const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
    
    const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
  
    // ===== Header =====
    graphics.drawString("Sales Tax Invoice", headerFont, null, blackBrush, 220, 10);

    graphics.drawString("Date:", boldFont, null, blackBrush, 490, 30);
    graphics.drawString(`${moment(invoiceDetails.date).format("DD-MMM-YY")}`, subFont, null, blackBrush, 525, 31);
  
    // ===== Buyer Info =====
    graphics.drawString("INVOICE:", boldFont, null, blackBrush, 10, 35);
    graphics.drawString(`${(invoiceDetails.invoiceNo).toUpperCase()}`, subFont, null, blackBrush, 55, 36);

    graphics.drawString("BUYER:", boldFont, null, blackBrush, 10, 65);
    // graphics.drawString(invoiceDetails.buyerName.toUpperCase(), subFont, null, blackBrush, 10, 85);
     this.wrapText(graphics,invoiceDetails.buyerName.toUpperCase(), subFont, blackBrush, 10, 80, 200, 10);
    
    // graphics.drawString(invoiceDetails.sellerAddress, subFont, null, blackBrush, 400, 105);
    this.wrapText(graphics, invoiceDetails.buyerAddress.toUpperCase(), subFont, blackBrush, 10, 90, 250, 10);
    
    
    graphics.drawString(`REGION:`, boldFont, null, blackBrush, 10, 115);
    graphics.drawString(`${(invoiceDetails.buyerRegion).toUpperCase()}`, subFont, null, blackBrush, 50, 116);
    
    graphics.drawString(`NTN:`, boldFont, null, blackBrush, 10, 130);

    graphics.drawString(`${invoiceDetails.buyerNTN.toUpperCase()}`, subFont, null, blackBrush, 35, 131);
    
    graphics.drawString(`TYPE:`, boldFont, null, blackBrush, 10, 145);

    graphics.drawString(`${invoiceDetails.buyerType.toUpperCase()}`, subFont, null, blackBrush, 40, 146);
  
    // ===== Seller Info =====
    graphics.drawString("SELLER:", boldFont, null, blackBrush, 350, 65);
    // graphics.drawString(invoiceDetails.sellerName, subFont, null, blackBrush, 400, 90);
    this.wrapText(graphics, invoiceDetails.sellerName, subFont, blackBrush, 350, 80, 200, 10);
    
    // graphics.drawString(invoiceDetails.sellerAddress, subFont, null, blackBrush, 400, 105);
    this.wrapText(graphics, invoiceDetails.sellerAddress, subFont, blackBrush, 350, 90, 200, 10);
    

    graphics.drawString(`REGION:`, boldFont, null, blackBrush, 350, 115);
    graphics.drawString(`${(invoiceDetails.sellerRegion).toUpperCase()}`, subFont, null, blackBrush, 390, 116);
    
    graphics.drawString(`NTN:`, boldFont, null, blackBrush, 350, 130);
    graphics.drawString(`${invoiceDetails.sellerNTN.toUpperCase()}`, subFont, null, blackBrush, 375, 131);
    


     graphics.drawString(`TYPE:`, boldFont, null, blackBrush, 350, 145);

    graphics.drawString(`REGISTERED`, subFont, null, blackBrush, 380, 146);
    // graphics.drawString(`Type:`, boldFont, null, blackBrush, 350, 155);
    // graphics.drawString(`${invoiceDetails.sellerType}`, subFont, null, blackBrush, 380, 155);
  
    // ===== Table =====
    const pdfGrid = new PdfGrid();
    pdfGrid.columns.add(13);
  // Set column widths
pdfGrid.columns.getColumn(0).width = 25;   // SR No.
pdfGrid.columns.getColumn(1).width = 50;   // SR No.
pdfGrid.columns.getColumn(2).width = 55;  // Description
pdfGrid.columns.getColumn(3).width = 45;   // HS Code
pdfGrid.columns.getColumn(4).width = 45;   // Quantity
pdfGrid.columns.getColumn(5).width = 35;   // Rate
pdfGrid.columns.getColumn(6).width = 65;   // Amount
pdfGrid.columns.getColumn(7).width = 35;   // Sales Tax
pdfGrid.columns.getColumn(8).width = 35;   // Extra Tax
pdfGrid.columns.getColumn(9).width = 40;   // Further Tax
pdfGrid.columns.getColumn(10).width = 40;   // FED
pdfGrid.columns.getColumn(11).width = 45;  // Discount
pdfGrid.columns.getColumn(12).width = 60;  // Total

    // Header row
    const header = pdfGrid.headers.add(1)[0];
    const headers = [
      "SR No.","Invoice Number (Detail)", "Document Description", "HS Code", "Quantity", "Rate", "Value of Sales Excl ST",
      "Sales Tax", "Extra Tax", "Further Tax", "FED Payable", "Discount", "Total Value"
    ];
    // headers.forEach((h, i) => {
    //   header.cells.getCell(i).value = h;
    //   header.cells.getCell(i).style.font = boldFont;
    // });

    const headersboldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    headers.forEach((h, i) => { 
      header.cells.getCell(i).value = h;
      header.cells.getCell(i).style.font = headersboldFont;
      header.cells.getCell(i).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
    
      // Apply header background + font color
      header.cells.getCell(i).style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 102, 128)); // teal blue
      header.cells.getCell(i).style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));    // white text
    });
  
    // Data rows
    invoiceItems.forEach((item,i) => {
      const row = pdfGrid.rows.addRow();
      row.cells.getCell(0).value = item.srNo.toString();
      row.cells.getCell(1).value = item.FBRSaleInvoiceDetailNo;
      row.cells.getCell(2).value = item.description;
      row.cells.getCell(3).value = item.hsCode;
      row.cells.getCell(4).value = item.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(5).value = item.rate;
      row.cells.getCell(6).value = item.amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });;
      row.cells.getCell(7).value = item.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      row.cells.getCell(8).value = item.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      row.cells.getCell(9).value = item.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      row.cells.getCell(10).value = item.fed.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      row.cells.getCell(11).value = item.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      row.cells.getCell(12).value = item.totalInclTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
      
      for (let c = 0; c < row.cells.count; c++) {
        row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center);
      }
    });
  
    pdfGrid.style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

    pdfGrid.style.cellPadding.all = 3;
    // pdfGrid.draw(page, { x: 0, y: 180 });
    const layoutResult = pdfGrid.draw(page, { x: 0, y: 180 });
 
  
    // ===== Totals =====
    console.log('layout result',layoutResult)
    let CalculateGap = invoiceItems?.length * 20
    let yBase = 310 + CalculateGap;

    // After drawing PdfGrid



    let xPos = page.getClientSize().width - 250;  // right aligned box
let yPos = layoutResult.bounds.height + layoutResult.bounds.y + 20; 
let boxWidth = 220;
let boxHeight = 140;

graphics.drawRectangle(new PdfPen(PdfColor.black, 1), xPos, yPos, boxWidth, boxHeight);

let lineHeight = 14;
let padding = 5;

// Function to measure and right-align text
function drawRightAligned(text, yOffset, font) {
    let textWidth = font.measureString(text).width;
    let drawX = xPos + boxWidth - padding - textWidth; // right edge inside box
    let drawY = yPos + yOffset;
    graphics.drawString(text, font, null, PdfBrushes.black, drawX, drawY);
}

drawRightAligned(`Value of Sales Excl ST: ${invoiceDetails.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8, subFont);
drawRightAligned(`Sales Tax (GST): ${invoiceDetails.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 1, subFont);
drawRightAligned(`Further Tax: ${invoiceDetails.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 2, subFont);
drawRightAligned(`Extra Tax: ${invoiceDetails.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 3, subFont);
drawRightAligned(`FED Payable: ${invoiceDetails.fedPayable.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 4, subFont);
drawRightAligned(`Discount: ${invoiceDetails.discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, 8 + lineHeight * 5, subFont);

drawRightAligned(
  `Grand Total Value : Rs. ${invoiceDetails.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  6 + lineHeight * 7,
  boldFont
);

    // ===== Amount in Words =====
    // graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
    // graphics.drawString(invoiceDetails.grandTotalInWords, boldFont, null, blackBrush, 10, yBase + 15);
  
    graphics.drawString("Total in words:", boldFont, null, blackBrush, 10, yBase);
    this.wrapText(graphics, invoiceDetails.grandTotalInWords, boldFont, blackBrush, 10, yBase + 15, 300, 15);


    //  // ===== IMAGE (Base64 PNG) =====
    const blobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
          reader.onerror = reject;
          reader.readAsDataURL(blob);
      });
    };
  
  

      const url = URL.createObjectURL(blob);

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
    
      const imageBlob = await response.blob();
      const imageBase64 = await blobToBase64(imageBlob);
    
     // Create PdfBitmap from Base64
     const image = new PdfBitmap(imageBase64);
       
     // Draw the image on the PDF
     let xImgPos = page.getClientSize().width - 115;  // right aligned box
      let yImgPos = layoutResult.bounds.height + layoutResult.bounds.y + 170; 
     graphics.drawImage(image, xImgPos, yImgPos,96 ,96 ); // Adjust x, y, width, height as needed
      


     // ==== FBR IMAGE DRAW ====
     const FBRIMGresponse = await fetch('/fbr-img.jpg');
     if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
     
             const FBRimageBlob = await FBRIMGresponse.blob();
             const FBRimageBase64 = await blobToBase64(FBRimageBlob);
     
            // Create PdfBitmap from Base64
            const FBRimage = new PdfBitmap(FBRimageBase64);
              
            // Draw the FBRimage on the PDF
            graphics.drawImage(FBRimage, 40, yImgPos,50 ,50 ); // Adjust x, y, width, height as needed
            // ===== Save or Return Blob =====
    if (type === 'save') {
      const pdfBlob = await document.save();
      document.destroy();
      return pdfBlob;
    } else {
      document.save("SalesTaxInvoice.pdf");
      document.destroy();
    }
  }














  // ===============================  Sales Tax Invoice  -  Format 2 ==================================
// Main PDF generation function matching exact PDF format
  async  generateSalesTaxInvoicePDF(mainSectionData ,detailSectionData , blob ,type = 'download',PdfMargins) {
    console.log(mainSectionData)
    const document = new PdfDocument();
    
    // Page settings
    // document.pageSettings.margins = new PdfMargins(0.25, 0.25, 1.5, 0.25); // Left, Right, Top, Bottom
    // try
    document.pageSettings.margins.left = PdfMargins.Left * 72;
    document.pageSettings.margins.right = PdfMargins.Right * 72;
    document.pageSettings.margins.top = PdfMargins.Top * 72;
    document.pageSettings.margins.bottom = PdfMargins.Bottom * 72;
    // try
//     document.pageSettings.margins = {
//   top: 1.5,
//   bottom: 0.25,
//   left: 0.25,
//   right: 0.25
// };

    document.pageSettings.size = PdfPageSize.a4;
    
    const page = document.pages.add();
    const graphics = page.graphics;
    const pageWidth = page.getClientSize().width;
    
    // Define fonts exactly as in original
    // === Fonts ===
    const titleFont = new PdfStandardFont(PdfFontFamily.Helvetica, 22, PdfFontStyle.Bold);
    // const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 11, PdfFontStyle.Bold | PdfFontStyle.Underline);
    const headerFont = new PdfStandardFont(PdfFontFamily.Helvetica, 11, PdfFontStyle.Bold );
    const normalFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9);
    const smallFont = new PdfStandardFont(PdfFontFamily.Helvetica, 8);
    const boldFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Bold);
    
    // === Brushes & Pen ===
    const blackBrush = new PdfSolidBrush(new PdfColor(0, 0, 0));
    const blackPen = new PdfPen(new PdfColor(0, 0, 0), 1);
    const lightBlueBrush = new PdfSolidBrush(new PdfColor(0, 102, 128));
    const whiteBrush = new PdfSolidBrush(new PdfColor(255, 255, 255));
 

// ====== main Section Columns ==== 
//  invoiceNo: invoice.FBRSaleInvoiceNo || "",
//         date: invoice.invoiceDate,
//         buyerName: invoice.buyerBusinessName,
//         buyerCompany: invoice.buyerBusinessName,
//         buyerRegion: invoice.buyerProvince,
//         buyerNTN: invoice.buyerNTNCNIC,
//         buyerType: invoice.buyerRegistrationType,
//         sellerName: invoice.sellerBusinessName,
//         buyerAddress: invoice.buyerAddress,
//         sellerCompany: invoice.sellerBusinessName,
//         sellerAddress: invoice.sellerAddress,
//         sellerNTN: invoice.sellerNTNCNIC,
//         sellerRegion: invoice.sellerProvince,
//         sellerType: invoice?.sellerRegistrationType,
//         subTotal: totalvalueSalesExcludingST,
//         salesTax: totalSalesTax,
//         furtherTax: totalFurtherTax,
//         extraTax: totalExtraTax,
//         fedPayable: totalFedPayable,
//         discount: totalDiscount,
        //grandTotal: grandTotal

  // === Title ===
  let yPosition = 120;
  graphics.drawString(
    "Sales Tax Invoice",
    titleFont,
    null,
    blackBrush,
    pageWidth / 2 - 70,
    yPosition - 40
  );

  // === HR Line ===
graphics.drawLine(blackPen, 0, yPosition - 10, pageWidth, yPosition - 10);

  // === Seller & Buyer Headings ===
  function drawUnderlinedTitle(graphics, text, font, brush, pen, x, y, padding = 0, maxWidth = 0, lineHeight = 0) {
  let lines = [];
  const fontSize = font.size || 12; // Get actual font size

  if (maxWidth > 0) {
    // Wrap text if width is provided
    lines = wrapText(text, font, maxWidth);
    lines.forEach((line, i) => {
      const currentY = y + (i * lineHeight);
      graphics.drawString(line, font, null, brush, x, currentY);
      
      // Draw underline below each line with consistent spacing
      const lineWidth = font.measureString(line).width;
      const underlineY = currentY + fontSize + 2; // Small consistent gap below text
      graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
    });
  } else {
    graphics.drawString(text, font, null, brush, x, y);
    lines = [text];
    
    // Draw underline below single line with consistent positioning
    const lineWidth = font.measureString(text).width;
    const underlineY = y + fontSize + (padding || 2); // Consistent padding for single line
    graphics.drawLine(pen, x, underlineY, x + lineWidth, underlineY);
  }
}

function wrapText(text, font, maxWidth) {
  let words = text.split(" ");
  let line = "";
  let lines = [];

  for (let n = 0; n < words.length; n++) {
    let testLine = line + words[n] + " ";
    let testWidth = font.measureString(testLine).width || 0;

    if (testWidth > maxWidth && n > 0) {
      lines.push(line.trim());
      line = words[n] + " ";
    } else {
      line = testLine;
    }
  }
  lines.push(line.trim());
  return lines;
}

  let sellerX = 0;
  let buyerX = pageWidth / 2 + 20;
  
drawUnderlinedTitle(graphics, "Seller Information", headerFont, blackBrush, blackPen, sellerX, yPosition);
drawUnderlinedTitle(graphics, "Buyer Information", headerFont, blackBrush, blackPen, buyerX, yPosition);


  // === Seller Business Name (with wrapping) ===
  
    graphics.drawString('Business Name:', normalFont, null, blackBrush, sellerX, yPosition + 20);
    drawUnderlinedTitle(graphics, (mainSectionData?.sellerName || '').toUpperCase() , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 20);

  // === Buyer Busniess  Name (with wrapping) ===
graphics.drawString('Business Name:', normalFont, null, blackBrush, buyerX, yPosition + 20);
drawUnderlinedTitle(graphics, (mainSectionData?.buyerName || '').toUpperCase() , normalFont, blackBrush, blackPen, buyerX + 95, yPosition + 20);


  // === Seller Address (with wrapping) ===
   graphics.drawString('Address:', normalFont, null, blackBrush, sellerX, yPosition + 35);
    drawUnderlinedTitle(graphics, 
      (mainSectionData?.sellerAddress || '').toUpperCase() , 
      normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 35,  5,                // padding below last line
      172,              // max width for wrapping
      16   ); 


// === Buyer Address (with wrapping) ===
graphics.drawString('Address:', normalFont, null, blackBrush, buyerX, yPosition + 35);
drawUnderlinedTitle(
  graphics,
  (mainSectionData?.buyerAddress || '').toUpperCase(),
  // `mainSectionData?.buyerAddress tddddttt tttt 777`,
  normalFont,
  blackBrush,
  blackPen,         // pass null if you don't want underline
  buyerX + 95,
  yPosition + 35,
  5,                // padding below last line
  172,              // max width for wrapping
  16                // line height (e.g., font.size + 4)
);


  // === Seller Other Details ===
//   graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX, yPosition + 70);
// drawUnderlinedTitle(graphics, mainSectionData?.sellerNTN || '' , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 70);
  
// graphics.drawString('Province:', normalFont, null, blackBrush, sellerX, yPosition + 85);
// drawUnderlinedTitle(graphics, mainSectionData?.sellerRegion || '' , normalFont, blackBrush, blackPen, sellerX + 95, yPosition + 85);
let sellerAddressWidth = normalFont.measureString(mainSectionData?.sellerAddress || '').width;
  console.log(sellerAddressWidth)
  //   graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX, yPosition + 70);
    graphics.drawString('Registration No:', normalFont, null, blackBrush, sellerX,  sellerAddressWidth < 169 ? yPosition + 50 : yPosition + 70);
drawUnderlinedTitle(graphics, mainSectionData?.sellerNTN || '' , normalFont, blackBrush, blackPen, sellerX + 95, sellerAddressWidth < 169 ? yPosition + 50 : yPosition + 70);
  
graphics.drawString('Province:', normalFont, null, blackBrush, sellerX, sellerAddressWidth < 169 ? yPosition + 65 : yPosition + 85);
drawUnderlinedTitle(graphics, mainSectionData?.sellerRegion || '' , normalFont, blackBrush, blackPen, sellerX + 95, sellerAddressWidth < 169 ? yPosition + 65 : yPosition + 85);

  // === Buyer Other Details ===
  let buyerAddressWidth = normalFont.measureString(mainSectionData?.buyerAddress || '').width;
  console.log(buyerAddressWidth)
  //   graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX, yPosition + 70);
    graphics.drawString('Registration No:', normalFont, null, blackBrush, buyerX,  buyerAddressWidth < 169 ? yPosition + 50 : yPosition + 70);
drawUnderlinedTitle(graphics, mainSectionData?.buyerNTN || '' , normalFont, blackBrush, blackPen, buyerX + 95, buyerAddressWidth < 169 ? yPosition + 50 : yPosition + 70);
  
graphics.drawString('Province:', normalFont, null, blackBrush, buyerX, buyerAddressWidth < 169 ? yPosition + 65 : yPosition + 85);
drawUnderlinedTitle(graphics, mainSectionData?.buyerRegion || '' , normalFont, blackBrush, blackPen, buyerX + 95, buyerAddressWidth < 169 ? yPosition + 65 : yPosition + 85);

 // === HR Line ===
 let drawlineHeight = sellerAddressWidth < 169 && buyerAddressWidth < 169 ? yPosition + 100 : yPosition + 120;
graphics.drawLine(blackPen, 0, drawlineHeight, pageWidth, drawlineHeight);
yPosition =sellerAddressWidth < 169 && buyerAddressWidth < 169 ? yPosition - 15 : yPosition;

// ====== invoice summary ======
drawUnderlinedTitle(graphics, "Invoice Summary ", headerFont, blackBrush, blackPen, sellerX, yPosition + 130);

 
// ===== FBR Invoice No === 
  graphics.drawString('FBR Invoice No:', normalFont, null, blackBrush, sellerX, yPosition + 161);
  graphics.drawString(mainSectionData?.invoiceNo || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 161);

// ===== Invoice Date === 
  graphics.drawString('Invoice Date:', normalFont, null, blackBrush, sellerX, yPosition + 172);
  graphics.drawString(`${moment(mainSectionData.date).format("DD-MMM-YY")}` || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 172);
// ===== Invoice Type === 
graphics.drawString('Invoice Type:', normalFont, null, blackBrush, sellerX, yPosition + 183);
  graphics.drawString(mainSectionData?.docDescription || '', normalFont, null, blackBrush, sellerX + 80, yPosition + 183);

// ===== Tax Period === 
graphics.drawString('Tax Period:', normalFont, null, blackBrush, sellerX, yPosition + 194);
  graphics.drawString(`${moment(mainSectionData.date).format("MMYYYY")}` || 'ask', normalFont, null, blackBrush, sellerX + 80, yPosition + 194);



  const blobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract only Base64 data
          reader.onerror = reject;
          reader.readAsDataURL(blob);
      });
    };
       // ==== FBR IMAGE DRAW ====
       const FBRIMGresponse = await fetch('/fbr-img.jpg');
       if (!FBRIMGresponse.ok) throw new Error(`Failed to fetch image: ${FBRIMGresponse.statusText}`);
       
               const FBRimageBlob = await FBRIMGresponse.blob();
               const FBRimageBase64 = await blobToBase64(FBRimageBlob);
       
              // Create PdfBitmap from Base64
              const FBRimage = new PdfBitmap(FBRimageBase64);
                
              // Draw the FBRimage on the PDF
              graphics.drawImage(FBRimage, page.getClientSize().width - 130, 0,80 ,80 ); // Adjust x, y, width, height as needed




              
    //  // ===== IMAGE (Base64 PNG) =====
    
  
  

      const url = URL.createObjectURL(blob);

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
    
      const imageBlob = await response.blob();
      const imageBase64 = await blobToBase64(imageBlob);
    
     // Create PdfBitmap from Base64
     const image = new PdfBitmap(imageBase64);
       
     // Draw the image on the PDF
     let xImgPos = page.getClientSize().width - 130;  // right aligned box
      let yImgPos = yPosition + 142;
     graphics.drawImage(image, xImgPos, yImgPos,130  ,130 ); // Adjust x, y, width, height as needed
      


      // === HR Line ===
graphics.drawLine(blackPen, 0, yPosition + 240, pageWidth, yPosition + 240);




    yPosition += 260;
    
    

    
  // ====== GRID CODE ====
    // ===== ITEMS TABLE (exactly as in image) =====
    const itemsGrid = new PdfGrid();
    itemsGrid.columns.add(12);
    
    // Optimized column widths for A4 page (total ~540px for better fit)
    itemsGrid.columns.getColumn(0).width = 25;   // SR No.
    itemsGrid.columns.getColumn(1).width = 55;   // Invoice Number (Detail) - reduced
    itemsGrid.columns.getColumn(2).width = 55;   // Document Description - reduced
    itemsGrid.columns.getColumn(3).width = 40;   // HS Code
    itemsGrid.columns.getColumn(4).width = 50;   // Quantity
    itemsGrid.columns.getColumn(5).width = 28;   // UOM
    itemsGrid.columns.getColumn(6).width = 32;   // Rate
    itemsGrid.columns.getColumn(7).width = 55;   // Value of Sales Excl ST
    itemsGrid.columns.getColumn(8).width = 55;   // Sales Tax
    itemsGrid.columns.getColumn(9).width = 55;   // Extra Tax
    itemsGrid.columns.getColumn(10).width = 53;  // Further Tax
    itemsGrid.columns.getColumn(11).width = 55;  // Total Value
    
    // Header row with black background and white text as in image
    const header = itemsGrid.headers.add(1)[0];
    const headers = [
      "SR No.", "Invoice Number (Detail)", "Document Description", "HS Code", "Quantity", "UOM",
      "Rate", "Value of Sales Excl ST", "Sales Tax", "Extra Tax", "Further Tax", "Total Value"
    ];
    
    headers.forEach((h, i) => {
      header.cells.getCell(i).value = h;
      header.cells.getCell(i).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold); // Smaller font
      header.cells.getCell(i).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle); // Center horizontal & vertical
      header.cells.getCell(i).style.backgroundBrush = new PdfSolidBrush(new PdfColor(0, 0, 0)); // Black background
      header.cells.getCell(i).style.textBrush = new PdfSolidBrush(new PdfColor(255, 255, 255)); // White text

       // Set white border
  const whitePen = new PdfPen(new PdfColor(255, 255, 255), 0.5); // 0.5pt white border
  header.cells.getCell(i).style.borders = {
    left: i === 0 ? blackPen : whitePen,
    right:i === 11 ? blackPen : whitePen,
    top: blackPen,
    bottom: whitePen
  };

    });
    
    // Data rows from detailRows array
    detailSectionData.forEach((item, i) => {
      const row = itemsGrid.rows.addRow();
      row.cells.getCell(0).value = item.srNo.toString();
      row.cells.getCell(1).value = item.FBRSaleInvoiceDetailNo;
      row.cells.getCell(2).value = item.description;
      row.cells.getCell(3).value = item.hsCode;
      row.cells.getCell(4).value = item.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(5).value = item?.uoM || '';
      row.cells.getCell(6).value = item.rate;
      row.cells.getCell(7).value = item.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(8).value = item.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(9).value = item.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(10).value = item.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      row.cells.getCell(11).value = item.totalInclTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      
      for (let c = 0; c < row.cells.count; c++) {
        switch (c) {
          case 4:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
           row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
            row.cells.getCell(c).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left
            break;
        
          default: row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

            break;
        }
       
        row.cells.getCell(c).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 6.5); // Smaller font for data
      }
    });
    
    // Add totals row with column spanning (0-3)
    const totalRow = itemsGrid.rows.addRow();
    
    // Merge cells 0-3 for "Total:" label with right alignment
    totalRow.cells.getCell(0).value = "Total:  ";
    totalRow.cells.getCell(0).columnSpan = 4; // Span columns 0-3
    totalRow.cells.getCell(0).style.stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle); // Right align
    totalRow.cells.getCell(0).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left

    totalRow.cells.getCell(0).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    
    // Set values for remaining columns (4-11)
    totalRow.cells.getCell(4).value = mainSectionData.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(5).value = ""; // UOM column empty
    totalRow.cells.getCell(6).value = ""; // Rate column empty
    totalRow.cells.getCell(7).value = mainSectionData.subTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(8).value = mainSectionData.salesTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(9).value = mainSectionData.extraTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(10).value = mainSectionData.furtherTax.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    totalRow.cells.getCell(11).value = mainSectionData.grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
    // Style remaining cells in totals row
    for (let c = 4; c < totalRow.cells.count; c++) {
      totalRow.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
      totalRow.cells.getCell(c).style.cellPadding = new PdfPaddings(0, 4, 0, 0); // top, right, bottom, left

      totalRow.cells.getCell(c).style.font = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
    }
    
    itemsGrid.style.font = smallFont;
    itemsGrid.style.cellPadding.all = 2; // Reduced padding for better fit
    
   let  layoutResult = itemsGrid.draw(page, { x: 0, y: yPosition });
   let yPos = layoutResult.bounds.height + layoutResult.bounds.y; 

   const italicFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Italic);
const blueBrush = new PdfSolidBrush(new PdfColor(83, 132, 208)); // #5384d0

graphics.drawString(
  'This is system generated Digital Invoice. No signature required.',
  italicFont,
  null,
  blueBrush,
  0,
  yPos + 30
);


 

    
    // ===== SAVE DOCUMENT =====
    if (type === 'save') {
      const pdfBlob = await document.save();
      document.destroy();
      return pdfBlob;
    } else {
      document.save(`SalesTaxInvoice.pdf`);
      document.destroy();
    }
  }

  // Sample data matching exact PDF format
 

}

export default new SaleInvoiceService();
